import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmacao',
  templateUrl: './confirmacao.component.html',
  styleUrls: ['./confirmacao.component.css']
})
export class ConfirmacaoComponent implements OnInit {

  descripcionProducto: string;
  nroBilhete: string;
  bilhetes: Array<string> = [];
  emailTitular: string;
  urlmostrarProductos: string;
  URLCotizacion: any;

  constructor(private routers:Router) { }

  ngOnInit() {

    this.URLCotizacion = JSON.parse(localStorage.URLParams);

    let datosEmision = JSON.parse(localStorage.getItem("emisionData")).ResponseJSONData;
    console.log(datosEmision["s:Envelope"]["s:Body"])

    if(Array.isArray(datosEmision["s:Envelope"]["s:Body"].CreateVoucherResponse.CreateVoucherResult["a:Vouchers"]["b:string"])) 
      this.bilhetes = datosEmision["s:Envelope"]["s:Body"].CreateVoucherResponse.CreateVoucherResult["a:Vouchers"]["b:string"]
    else 
      this.bilhetes.push(datosEmision["s:Envelope"]["s:Body"].CreateVoucherResponse.CreateVoucherResult["a:Vouchers"]["b:string"])

    this.nroBilhete = datosEmision["s:Envelope"]["s:Body"].CreateVoucherResponse.CreateVoucherResult["a:VoucherNumber"]
    this.emailTitular = localStorage.getItem("email")
    this.descripcionProducto = JSON.parse(localStorage.getItem("ProductoSeleccionado")).DescricaoProduto    
  }

  GotoMostrarProductos(){
    this.routers.navigate(['/MostrarProdutos']);
  }

  GotoFazerCotacao(){

   console.log("HOLA QUE TAL",this.URLCotizacion);  
    this.urlmostrarProductos = '/Cotacao?'+this.URLCotizacion;

    this.urlmostrarProductos.replace(' ','');
    this.routers.navigate(['/Cotacao'],{queryParams:this.URLCotizacion});
  
  } 



}
